<template>
  <div
    :class="{ html2pdf__page: asContent }"
    :slot="asContent ? 'pdf-content' : null"
  >
    <section class="html2pdf__page-break px-4 pt-1 space-y-2 text-sm" style="font-family: 'Courier New', Courier, monospace !important;">
      <div class="flex items-center justify-between gap-8">
        <div class="flex-shrink-0 whitespace-nowrap">
          <p>PT. NATURAL NUSANTARA</p>
          <p class="text-xs">Jl. Ring Road Barat No. 72 Salakan</p>
          <p class="text-xs">Trihanggo Gamping Sleman Jogjakarta</p>
          <p class="text-xs">Telp : 0274-6499191</p>
          <p class="text-xs">Fax : 0274-6499192, 0274-6499193</p>
        </div>
        <p class="font-bold text-lg whitespace-nowrap">TANDA TERIMA BARANG</p>
        <div>
          <div class="grid grid-cols-9">
            <p class="col-span-4">Nomor</p>
            <p>:</p>
            <p class="col-span-4">{{ order.code }}</p>
          </div>
          <div class="grid grid-cols-9">
            <p class="col-span-4">Tanggal</p>
            <p>:</p>
            <p class="col-span-4 font-bold">{{ order.date | formatDate('DD/MM/YYYY') }}</p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-12 pb-4">
        <p class="col-span-3">Kode Stockist</p>
        <p>:</p>
        <p class="col-span-8">{{ order.destinationOfficeCode }}</p>

        <p class="col-span-3">Nama Stockist</p>
        <p>:</p>
        <p class="col-span-8">{{ order.destinationOfficeName }}</p>

        <p class="col-span-3">Alamat Stockist</p>
        <p>:</p>
        <p class="col-span-8">{{ order.destinationOfficeAddress }}</p>

        <p class="col-span-3">Alamat Pengiriman</p>
        <p>:</p>
        <p class="col-span-8">{{ order.orderAddress }}</p>

        <p class="col-span-3">Metode Pengiriman</p>
        <p>:</p>
        <p class="col-span-8">{{ order.shipmentType === 'pickup' ? 'Diambil' : 'Dikirim' }}</p>

        <p class="col-span-3">Tipe Faktur</p>
        <p>:</p>
        <p class="col-span-8">{{ order.type }}</p>
      </div>

      <table class="border w-full border-black text-sm">
        <template v-if="displayPerPacket">
          <tr class="border-b border-black">
            <th class="pb-4 px-4 text-left">No Koli</th>
            <th class="pb-4 px-4 text-left">Kode</th>
            <th class="pb-4 px-4 text-left">Nama Barang</th>
            <th class="pb-4 px-4 text-right">Jumlah</th>
            <th class="pb-4 px-4 text-right">Berat/KG</th>
          </tr>
          <tbody class="border-b border-black">
            <tr v-for="(detail, i) in productInPackets" :key="detail.id">
              <td class="pb-4 px-4">{{ i === 0 || detail.packet_code !== productInPackets[i - 1].packet_code ? detail.packet_code : '' }}</td>
              <td class="pb-4 px-4">
                <p v-if="detail.product_type === 'reguler'">{{ detail.product_code }}</p>
                <p v-else>{{ detail.product_code }} (FREE)</p>
              </td>
              <td class="pb-4 px-4">{{ detail.product_name }}</td>
              <td class="pb-4 px-4 text-right">{{ detail.product_qty }}</td>
              <td class="pb-4 px-4 text-right">{{ detail.product_weight | toFixed }}</td>
            </tr>
          </tbody>
        </template>
        <template v-else-if="displayPerProduct">
          <tr class="border-b border-black">
            <th class="pb-4 px-4 text-left">No Koli</th>
            <th class="pb-4 px-4 text-left">Kode</th>
            <th class="pb-4 px-4 text-left">Nama Barang</th>
            <th class="pb-4 px-4 text-right">Jumlah</th>
            <th class="pb-4 px-4 text-right">Berat/KG</th>
          </tr>
          <tbody class="border-b border-black">
            <tr v-for="(detail, i) in detailsSortByPacketCode" :key="detail.id">
              <td class="pb-4 px-4">{{ i === 0 || detail.attributes.packet_code !== detailsSortByPacketCode[i - 1].packet_code ? detail.attributes.packet_code : '' }}</td>
              <td class="pb-4 px-4">
                <p v-if="detail.attributes.product_type === 'reguler'">{{ detail.attributes.product_code }}</p>
                <p v-else>{{ detail.attributes.product_code }} (FREE)</p>
              </td>
              <td class="pb-4 px-4">{{ detail.attributes.product_name }}</td>
              <td class="pb-4 px-4 text-right">{{ detail.attributes.shipped_product_qty }}</td>
              <td class="pb-4 px-4 text-right">{{ detail.attributes.product_weight | toFixed }}</td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <tr class="border-b border-black">
            <th class="pb-4 px-4 text-left">Kode</th>
            <th class="pb-4 px-4 text-left">Nama Barang</th>
            <th class="pb-4 px-4 text-right">Jumlah</th>
            <th class="pb-4 px-4 text-right">Jumlah</th>
            <th class="pb-4 px-4 text-right">Berat/KG</th>
          </tr>
          <tbody class="border-b border-black">
            <tr v-for="detail in order.details" :key="detail.id">
              <td class="pb-4 px-4">{{ detail.product_code }}</td>
              <td class="pb-4 px-4">{{ detail.product_name }}</td>
              <td class="pb-4 px-4 text-right">{{ detail.product_qty }}</td>
              <td class="pb-4 px-4 text-right">{{ detail.product_weight | toFixed }}</td>
            </tr>
          </tbody>
        </template>
        <tr class="border-b border-black">
          <td colspan="3" class="pb-4 px-4">
            <strong>Keterangan:</strong>
          </td>
          <td class="pb-4 text-right">Total Berat:</td>
          <td class="pb-4 px-4 text-right">{{ totalWeight | toFixed }}</td>
        </tr>
        <tr>
          <td colspan="5" class="pb-4 px-4">
            <div class="flex justify-between items-end mb-2">
              <div>
                <p class="text-xs">Barang-barang di atas telah diterima dalam keadaan baik dan lengkap</p>
                <div class="text-sm flex">
                  <span class="mr-4">Tanggal</span>
                  <div class="pt-2 border-b border-dashed border-gray-400 pb-2 flex">
                    <div class="text-right" style="width: 32px;">/</div>
                    <div class="text-right" style="width: 46px;">/</div>
                    <div class="text-right" style="width: 56px;"></div>
                  </div>
                </div>
                <div style="width: 210px;">
                  <div style="height: 50px;" class="border-b border-dashed border-gray-400"></div>
                  <p class="text-xs text-center">Penerima</p>
                </div>
              </div>
              <div>
                <div style="width: 180px;" class="text-center">
                  <strong>PT. NATURAL NUSANTARA</strong>
                  <div style="height: 80px;" class="border-b border-dashed border-gray-400"></div>
                  <p class="text-xs">Pengirim</p>
                </div>
              </div>
            </div>
            <p>
              <strong>Catatan</strong> : <span class="text-xs">Pengaduan / komplain barang tidak dilayani setelah tanda terima ini ditandatangani</span>
            </p>
            <p  v-if="stockMovement && stockMovement.attributes.expedition_name">
              <strong>Dikirim Via</strong> : <span class="text-xs">{{ stockMovement.attributes.expedition_name }}</span>
            </p>
          </td>
        </tr>
      </table>
      <template v-if="followUpProducts.data.length">
        <p class="font-bold pb-4">Susulan</p>
        <table class="border w-full border-black text-sm">
          <tr class="border-b border-black">
            <th class="pb-4 px-4 text-left">Kode Barang</th>
            <th class="pb-4 px-4 text-left">Nama Barang</th>
            <th class="pb-4 px-4 text-right">Jumlah</th>
          </tr>
          <tbody class="border-b border-black">
            <tr v-for="product in followUpProducts.data" :key="product.id">
              <td class="pb-4 px-4">{{ product.attributes.product_code }} {{ product.attributes.product_type === 'free' ? '(FREE)' : '' }}</td>
              <td class="pb-4 px-4">{{ product.attributes.product_name }}</td>
              <td class="pb-4 px-4 text-right">{{ product.attributes.qty }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-if="groupedProducts.data.length">
        <p class="font-bold pb-4">Grup</p>
        <table class="border w-full border-black text-sm">
          <tr class="border-b border-black">
            <th class="pb-4 px-4 text-left">Kode Barang</th>
            <th class="pb-4 px-4 text-left">Nama Barang</th>
            <th class="pb-4 px-4 text-right">Jumlah</th>
          </tr>
          <tbody class="border-b border-black">
            <tr v-for="product in groupedProducts.data" :key="product.id">
              <td class="pb-4 px-4">{{ product.attributes.product_code }} {{ product.attributes.product_type === 'reimbursement' ? '(Reimbursement)' : '(Susulan)' }}</td>
              <td class="pb-4 px-4">{{ product.attributes.product_name }}</td>
              <td class="pb-4 px-4 text-right">{{ product.attributes.qty }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <div v-if="simpleLink || link" class="flex gap-2 justify-end pt-4 mt-8">
        <div v-if="simpleLink" class="p-4 border rounded">
          <qr-code :text="simpleLink" :size="150" />
        </div>
        <div v-if="link" class="p-4 border rounded">
          <qr-code :text="link" :size="150" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import QrCode from 'vue-qrcode-component';
import { requestMixin } from '../mixins/request/request';
export default {
  name: 'PrintKemasan',
  mixins: [requestMixin],
  components: { QrCode },
  props: {
    asContent: {
      type: Boolean,
      default: false,
    },
    stockMovement: Object,
    order: {
      type: Object,
      default: () => ({
        id: null,
        code: null,
        date: null,
        destinationOfficeCode: null,
        destinationOfficeName: null,
        destinationOfficeAddress: null,
        orderAddress: null,
        details: []
      })
    },
    packets: Array,
    displayPerPacket: Boolean,
    displayPerProduct: Boolean,
    details: Array
  },
  data() {
    return {
      followUpProducts: {
        data: []
      },
      groupedProducts: {
        data: []
      }
    }
  },
  watch: {
    stockMovement: {
      immediate: true,
      handler() {
        if (this.stockMovement.id) {
          this.loadFollowUpProducts()
        }
      }
    },
    order: {
      immediate: true,
      handler(current, old) {
        if (current && current.id && old?.id !== current.id) {
          this.loadGroupedProducts()
        }
      }
    }
  },
  computed: {
    simpleLink() {
      if (!this.stockMovement || !this.stockMovement) {
        return null
      }

      return this.stockMovement.id
    },
    link() {
      if (!this.stockMovement || !this.stockMovement.attributes) {
        return null
      }

      return window.location.host + `/terima/${this.stockMovement.attributes.code}`;
    },
    productInPackets() {
      if (!this.stockMovement || !this.stockMovement.attributes.packets) {
        return []
      }

      return this.stockMovement.attributes.packets.flatMap(packet => packet.products.map(product => ({
        id: `${packet.uuid}-${product.uuid}`,
        packet_code: packet.code,
        product_code: product.product_code,
        product_name: product.product_name,
        product_type: product.product_type,
        product_qty: product.shipped_product_qty,
        product_weight: product.product_weight * product.shipped_product_qty
      })))
    },
    totalWeight() {
      if (this.displayPerProduct) {
        return this.details.reduce((sum, product) => sum + product.attributes.product_weight, 0)
      }

      return this.productInPackets.reduce((sum, product) => sum + product.product_weight, 0)
    },
    detailsSortByPacketCode() {
      return [...this.details].sort((a, b) => a.attributes.packet_code.localeCompare(b.attributes.packet_code))
    }
  },
  methods: {
    async loadFollowUpProducts() {
      const [res, err] = await this.request(`/api/v1/stock-movements/${this.stockMovement.id}/follow-up-products`)

      if (!err) {
        this.followUpProducts = res
      }
    },
    async loadGroupedProducts() {
      const [res, err] = await this.request(`/api/v1/orders/${this.order.id}/group-items`)

      if (!err) {
        this.groupedProducts = res
      }
    }
  }
};
</script>
